import ErrorLayout from './ErrorLayout';

export default ErrorLayout;
